"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCurrency = exports.getCurrencySymbol = exports.STANDARD_HIDDEN_CURRENCIES = exports.HIDE_CURRENCY_UNLESS_PRIORITY = exports.VAT_INCLUSIONS = exports.SYMBOLS = exports.CURRENCIES = void 0;
exports.CURRENCIES = [
    'AED',
    'AUD',
    'BRL',
    'CAD',
    'CHF',
    'CLP',
    'CNY',
    'COP',
    'DKK',
    'EGP',
    'EUR',
    'GBP',
    'HKD',
    'IDR',
    'ILS',
    'INR',
    'JPY',
    'KRW',
    'MXN',
    'MYR',
    'NZD',
    'PEN',
    'PHP',
    'PKR',
    'PLN',
    'SAR',
    'SEK',
    'SGD',
    'THB',
    'TRY',
    'TWD',
    'UAH',
    'USD',
    'VND',
    'ZAR'
];
exports.SYMBOLS = {
    AED: 'AED',
    AUD: '$',
    BRL: 'R$',
    CAD: 'C$',
    CHF: 'CHF',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    DKK: 'kr',
    EGP: 'EGP',
    EUR: '€',
    GBP: '£',
    HKD: 'HK$',
    IDR: 'Rp',
    ILS: '₪',
    INR: '₹',
    JPY: '¥',
    KRW: '₩',
    MXN: 'MXN',
    MYR: 'RM',
    NZD: '$',
    PEN: 'S/',
    PHP: '₱',
    PLN: 'zł',
    PKR: '₨',
    SAR: 'SAR',
    SEK: 'kr',
    SGD: 'SG$',
    THB: '฿',
    TRY: '₺',
    TWD: 'NT$',
    UAH: '₴',
    USD: '$',
    VND: '₫',
    ZAR: 'R'
};
exports.VAT_INCLUSIONS = ['ALL', 'NONE', 'TAXES', 'ICANN'];
exports.HIDE_CURRENCY_UNLESS_PRIORITY = [
// If a priority currency is available in MARKET_DETAILS list,
// it can be added here to hide it from the standard list for other markets
];
exports.STANDARD_HIDDEN_CURRENCIES = {
    BRL: ['pt-BR'],
    EGP: ['ar-AE', 'en-AE'],
    TRY: ['tr-TR']
};
function getCurrencySymbol(currency) {
    return exports.SYMBOLS[currency];
}
exports.getCurrencySymbol = getCurrencySymbol;
function validateCurrency(currency) {
    return exports.CURRENCIES.includes(currency);
}
exports.validateCurrency = validateCurrency;
